import React, { useRef } from 'react';

export interface BodyMapPoint {
  x: number; // 0-100 percentage of image width
  y: number; // 0-100 percentage of image height
}

interface WoundBodyMapProps {
  value: BodyMapPoint | null;
  onChange: (point: BodyMapPoint | null) => void;
}

const WoundBodyMap: React.FC<WoundBodyMapProps> = ({ value, onChange }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.round(((e.clientX - rect.left) / rect.width) * 10000) / 100;
    const y = Math.round(((e.clientY - rect.top) / rect.height) * 10000) / 100;
    onChange({ x, y });
  };

  return (
    <div className='space-y-1.5'>
      <div
        ref={containerRef}
        className='relative cursor-crosshair border rounded-md overflow-hidden bg-white select-none'
        onClick={handleClick}
      >
        <img
          src='/assets/wcbodymap-cropped.svg'
          alt='Body map — click to mark wound location'
          className='w-full h-auto block pointer-events-none'
          draggable={false}
        />
        {value && (
          <div
            className='absolute w-4 h-4 bg-red-500 rounded-full border-2 border-white shadow-md pointer-events-none'
            style={{
              left: `${value.x}%`,
              top: `${value.y}%`,
              transform: 'translate(-50%, -50%)',
            }}
          />
        )}
      </div>
      {value ? (
        <button
          type='button'
          onClick={e => {
            e.stopPropagation();
            onChange(null);
          }}
          className='text-xs text-muted-foreground underline hover:text-foreground'
        >
          Clear selection
        </button>
      ) : (
        <p className='text-xs text-muted-foreground'>
          Click on the diagram to mark the wound location
        </p>
      )}
    </div>
  );
};

export default WoundBodyMap;
